import { useParams } from 'react-router-dom';
import { capitalize } from 'lodash';
import { WorkbenchStatusEnum } from '~/api/types';
import { useGetProjectQuery, useGetProjectWorkbenchesQuery, useGetWorkbenchTypesQuery } from '~/api/v2/hooks';
import { TableFilterType } from '~/components/Table/components/filters/types';
import { WorkbenchFiltersType } from '~/pages/ProjectDetailsPage/tabs/WorkbenchTab/types';

interface FiltersWorkbenchConfig {
  showTerminated: boolean;
}

const useFiltersWorkbenchConfig = ({ showTerminated }: FiltersWorkbenchConfig) => {
  const projectId = +useParams().projectid!;
  const { data: workbenchTypesData } = useGetWorkbenchTypesQuery({
    projectId,
  });
  const { data: workbenchesEntryData } = useGetProjectWorkbenchesQuery(
    {
      projectId,
      showTerminated,
    },
    { skip: !projectId },
  );

  const { data: projectData } = useGetProjectQuery({ projectId }, { skip: !projectId });

  const filterOptions = [
    {
      id: WorkbenchFiltersType.STATUS,
      name: 'Status',
      type: TableFilterType.CHECKBOX,
      options: Object.values(WorkbenchStatusEnum)
        .map((workbench) => ({
          id: workbench,
          label: capitalize(workbench),
        }))
        .filter((option) => workbenchesEntryData?.data.some((workbench) => workbench.status === option.id)),
    },
    {
      id: WorkbenchFiltersType.TYPE,
      name: 'Type',
      type: TableFilterType.MULTIPLE_AUTOCOMPLETE,
      options:
        workbenchTypesData &&
        Object.keys(workbenchTypesData || {})
          .flatMap((workbenchGroup) => {
            const workbenchTypes = workbenchTypesData[workbenchGroup];

            return workbenchTypes.map((workbenchType) => ({
              id: workbenchType.id,
              label: `${workbenchGroup} - ${workbenchType.name}`,
            }));
          })
          .filter((option) => workbenchesEntryData?.data.some((workbench) => workbench.instance_type === option.id)),
    },
    {
      id: WorkbenchFiltersType.CREATED_ON,
      name: 'Created On',
      type: TableFilterType.DATE,
    },
    {
      id: WorkbenchFiltersType.CREATED_BY,
      name: 'Created By',
      type: TableFilterType.MULTIPLE_AUTOCOMPLETE,
      options: projectData?.members
        .map((config) => ({
          id: config.id,
          label: `${config.first_name} ${config.last_name}`,
        }))
        .filter((option) => workbenchesEntryData?.data.some((workbench) => workbench.creator.id === option.id)),
    },
  ];

  return filterOptions;
};

export default useFiltersWorkbenchConfig;
